export enum SMRTabEnum {
  Sales = "Sales",
  Medical = "Medical",
  Agreement = "Agreement",
}